const badgeBackgroundColors = [
    'red',
    'yellow',
    'green',
    'orange',
    'blue',
    'neonYellow',
    'stone',
    'grayHighContrast',
    'grayLowContrast',
    'black',
    'white',
];

export { badgeBackgroundColors };
